define('app/view-manager',['require'],function(require){

  var ViewManager = function(site){
    this.initialize.call(this, site);
  };

  _.extend(ViewManager.prototype, {

    site: null,
    views: {},

    initialize: function(site){
      this.setSite(site);
    },

    setSite: function(site){
      this.site = site;
    },

    getSite: function(){
      return this.site;
    },

    register: function(view, Class){
      if(!this.views[view]){
        this.views[view] = Class;
        return true;
      } else {
        console.log('view manager has already registered view: ' + view);
        return false;
      }
    },

    get: function(view){
      if(this.views[view]) {
        return this.views[view];
      } else {
        console.log('view manager could not find view: ' + view);
        return false;
      }
    },

    remove: function(view){
      if(this.views[view]) {
        this.views = _.omit(this.views, view);
        return true;
      } else {
        console.log('view manager could not find view: ' + view);
        return false;
      }
    }

  });

  return ViewManager;

});
